module.exports = __webpack_public_path__ + "img/connection-icon.a4a1bf61.svg";